import toursManifest from '../pages/constants/tours-manifest.json';

function cloneJson(data) {
  return JSON.parse(JSON.stringify(data));
}

function toOptimizedImagePath(imagePath) {
  if (!imagePath || typeof imagePath !== 'string') {
    return imagePath;
  }

  if (imagePath.startsWith('/optimized/public/')) {
    return imagePath;
  }

  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  const optimizedPath = normalizedPath.replace(/\.(jpg|jpeg|png)$/i, '.webp');

  return `/optimized/public${optimizedPath}`;
}

function applyOptimizedImages(metadata, config) {
  if (!metadata?.useOptimizedImages || !Array.isArray(config)) {
    return config;
  }

  return config.map((scene) => ({
    ...scene,
    image: toOptimizedImagePath(scene?.image),
  }));
}

function getTourConfigModule(tourId) {
  const configContext = require.context('../pages/constants', false, /^\.\/tour-config-.*\.json$/);
  const configPath = `./tour-config-${tourId}.json`;

  if (!configContext.keys().includes(configPath)) {
    return null;
  }

  return configContext(configPath);
}

export function getStaticTours() {
  return cloneJson(toursManifest);
}

export function getStaticTourById(tourId) {
  const tours = getStaticTours();
  const metadata = tours.find((tour) => tour.id === tourId);

  if (!metadata) return null;

  const config = getTourConfigModule(tourId);
  if (!config) return null;

  return {
    metadata,
    config: applyOptimizedImages(metadata, cloneJson(config)),
  };
}
